import { render, staticRenderFns } from "./LendersList.vue?vue&type=template&id=f67250e6&scoped=true&"
import script from "./LendersList.vue?vue&type=script&lang=js&"
export * from "./LendersList.vue?vue&type=script&lang=js&"
import style0 from "./LendersList.vue?vue&type=style&index=0&id=f67250e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67250e6",
  null
  
)

export default component.exports